<template>
  <div class="reminder-item">

    <!-- Icon -->
    <div>
      <feather-icon icon="ClockIcon" class="mr-50 h-6 w-6" />
    </div>

    <!-- Display -->
    <div id="item" class="mr-50">
      <div
        v-if="!activeForm"
        @click="openReminderEdit(reminder)"
        class="hover:text-primary"
      >
        <span> {{ durationDisplay }} </span>
      </div>
      <div v-else class="w-full">
        <b-form inline class="gap-1 w-full flex-wrap">
          <b-form-input
            class="inline"
            :id="`${idx}-reminder-time`"
            v-model="reminderForm.time"
          />
          <b-form-select
            class="inline"
            :id="`${idx}-reminder-time-unit`"
            v-model="reminderForm.unit"
            :options="timeUnits"
          />
        </b-form>
      </div>
    </div>

    <!-- Actions -->
    <div v-if="!disabled">
      <feather-icon
        v-if="!activeForm"
        @click="removeReminder(reminder)"
        icon="Trash2Icon"
        size="21"
        class="h-5 w-5 stroke-current text-danger cursor-pointer float-right"
      />
      <div class="float-right flex gap-1 flex-row" v-else>
        <feather-icon
          @click="saveEdit()"
          icon="PlusIcon"
          size="21"
          class="h-5 w-5 stroke-current text-success cursor-pointer"
        />
        <feather-icon
          v-if="idx !== null && idx >= 0"
          @click="cancelEdit()"
          icon="XCircleIcon"
          size="21"
          class="h-5 w-5 stroke-current text-danger cursor-pointer"
        />
      </div>
    </div>

  </div>
</template>

<script>
import { BFormInput, BRow, BCol, BFormSelect, BForm } from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
export default {
  components: {
    BFormInput,
    BRow,
    BCol,
    BFormSelect,
    BForm,
    FeatherIcon,
  },
  props: {
    idx: {
      type: Number,
      default: null
    },
    reminder: {
      type: Object,
      default: {
        minutes: null
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    reminderForm: {
      time: 5,
      unit: 'min'
    },
    editing: false,
    timeUnits: [
      { value: 'min', text: 'Minutos' },
      { value: 'hour', text: 'Horas' },
      { value: 'day', text: 'Dias' },
    ]
  }),
  computed: {
    activeForm() {
      return this.editing || (this.idx !== 0 && this.idx === null)
    },
    durationDisplay() {
      this.$moment.relativeTimeThreshold('ss', 1)
      this.$moment.relativeTimeThreshold('s', 60)
      this.$moment.relativeTimeThreshold('m', 60)
      this.$moment.relativeTimeThreshold('h', 24)
      this.$moment.relativeTimeThreshold('w', 4)

      const minutes = this.reminder && this.reminder.minutes
      return this.$moment.duration(minutes, 'minutes').humanize(false);
    }
  },
  methods: {
    openReminderEdit(reminder) {
      if (disabled) return
      this.$emit('edit', this.idx)
      this.editing = true
      const minutes = this._.get(reminder, 'minutes')
      // const duration = this.$moment.duration(minutes, 'minutes')
      this.reminderForm.time = minutes
      this.reminderForm.unit = 'min'
    },
    closeReminderEdit() {
      this.editing = false
      this.reminderForm = {
        time: 5,
        unit: 'min'
      }
    },
    cancelEdit() {
      this.closeReminderEdit()
    },
    saveEdit() {
      const time = parseFloat(this.reminderForm.time)
      const unit = this.reminderForm.unit

      const minutes = this.getTimeInMinutes(time, unit)

      this.$emit('input', this.idx, {
        minutes
      })

      this.closeReminderEdit()
    },
    removeReminder() {
      this.$emit('remove', this.idx)
    },
    getTimeInMinutes(time, unit) {
      switch (unit) {
        case 'min':
          return time
        case 'hour':
          return time * 60
        case 'day':
          return time * (60 * 24)
      }
    }
  },
}
</script>

<style lang="scss">
.reminder-item {
  @apply flex flex-row gap-1 w-full;
  &:hover {
    color: rgba(var(--vs-primary));
  }

  /*@screen sm {
    width: 70%;
  }

  @screen md {
    width: 57%;
  }

  @screen lg {
    width: 55%;
  }*/

  min-height: 2.75rem !important;
  align-items: center;
}
</style>